import React from 'react'
import { Hero } from './components/Hero.jsx'
import  { FeaturedProduct } from "./components/FeaturedProduct.jsx"
import { Testimonials } from './components/Testimonials.jsx'
import { Faq } from './components/Faq.jsx'





export const HomePage = () => {
  return (
    <main className="w-full">
      {/* <div className="flex-grow"> */}
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <Hero />
        </section>
        
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <FeaturedProduct />
        </section>
        
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <Testimonials />
        </section>
        
        <section className="mb-8 sm:mb-12 lg:mb-16">
          <Faq />
        </section>
      {/* </div> */}
    </main>
  );
};

// export const HomePage = () => {
//   return (
//     <main>
//       <Hero />
//       <FeaturedProduct />
//       <Testimonials />
//       <Faq />
//     </main>
//   )
// }
